<app-nav></app-nav>
<app-top-header></app-top-header>

<div class="ParentSectionSection_Components_HTally">

    <div class="Body_ParentSectionSection_Components_HTally">
        <div class="InnerPart_Body_Renter_Htally">
            <div class="Parent_ActivityList_Dashboard TabsSection">

                <div class="InnerBodyOfComponents">
                    <div class="TabsHeader">
                        <div class="RemainActivityList_Tab_Button">
                            <button (click)="selectTab('Renter')"
                                [class.active]="activeTab === 'Renter'">{{ 'renter.renterTab' | t:'Renter' }}<span></span></button>

                            <button (click)="selectTab('AssignFlat')" [class.active]="activeTab === 'AssignFlat'">{{ 'renter.assignFlatTab' | t:'Flat Assignment' }}<span></span></button>
                        </div>

                        <div class="TabsActions" *ngIf="activeTab === 'Renter'">
                            <button class="FilterBTN" [class.active-filter]="isFilterActive()" type="button" (click)="toggleFilter()">
                                {{ 'common.filter' | t:'Filter' }}
                            </button>
                            <button class="PositiveBTN" type="button" (click)="openNewRenter()">
                                {{ 'renter.addRenter' | t:'Add Renter' }}
                            </button>
                        </div>

                        <div class="TabsActions" *ngIf="activeTab === 'AssignFlat'">
                            <button class="FilterBTN" [class.active-filter]="isFilterActive()" type="button" (click)="toggleFilter()">
                                {{ 'common.filter' | t:'Filter' }}
                            </button>
                            <button class="PositiveBTN" type="button" (click)="openCreateAssign()">
                                {{ 'renter.assignFlat' | t:'Assign Flat' }}
                            </button>
                        </div>
                    </div>

                    <div *ngIf="activeTab === 'Renter'" class="RemainActivityList_tab_content">
                        <app-renter-list (postCreateUploadFinished)="handleRenterPostCreateUploadFinished()"></app-renter-list>
                    </div>

                    <div *ngIf="activeTab === 'AssignFlat'" class="RemainActivityList_tab_content">
                        <app-assign-flat></app-assign-flat>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<app-add-edit-renter
    *ngIf="showNewRenter"
    [mode]="'create'"
    (close)="closeNewRenter()"
    (save)="handleRenterSave($event)"
></app-add-edit-renter>

<div class="modal-overlay prompt-overlay" *ngIf="showPostCreateAssignPrompt && pendingCreatedRenterForAssign" (click)="closePostCreateAssignPrompt()">
    <div class="post-create-prompt-modal" (click)="$event.stopPropagation()">
        <h3>{{ 'renter.postCreatePromptTitle' | t:'Assign flat for renter' }} "{{ pendingCreatedRenterForAssign.renterName }}"?</h3>
        <p>{{ 'renter.postCreatePromptMessage' | t:'You can assign a flat now or skip this step for later.' }}</p>
        <div class="post-create-prompt-actions">
            <button type="button" class="panel-item" (click)="closePostCreateAssignPrompt()">{{ 'common.skipForNow' | t:'Skip for now' }}</button>
            <button type="button" class="PositiveBTN" (click)="openAssignCreateFromRenterPrompt()">{{ 'renter.assignFlat' | t:'Assign Flat' }}</button>
        </div>
    </div>
</div>

<app-filter-modal
    *ngIf="showFilter && (activeTab === 'Renter' || activeTab === 'AssignFlat')"
    [fields]="activeTab === 'Renter' ? renterFilterFields : assignFilterFields"
    [value]="activeTab === 'Renter' ? renterFilterValues : assignFilterValues"
    (apply)="applyFilters($event[0], $event[1])"
    (reset)="resetFilters()"
    (close)="toggleFilter()"
></app-filter-modal>
